import { colors } from '@alixpartners/ui-components';
import styled, { keyframes } from 'styled-components';
import { timingFunctions, transparentize } from 'polished';

const fadeInAndScale = keyframes`
	from { opacity: 0; transform: scale(0.925) }
`;

const spinner = keyframes`
	from {
		opacity: 1;
	}

	to {
		transform: rotate(360deg);
		opacity: 1;
	}
`;

const scaleIn = keyframes`
	from {
		transform: scale(0.8) rotate(-120deg);
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeInAndScale} 666ms ${timingFunctions('easeOutExpo')} 1;
`;

export const Spinner = styled.span`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: ${(props) => `4px solid ${transparentize(0.666, colors.green1)}`};
  border-top-color: ${colors.green1};
  opacity: 0;
  animation: ${scaleIn} 200ms linear 1 0ms,
    ${spinner} 600ms linear infinite 200ms;
`;

export const Label = styled.span`
  margin-top: 16px;
  font-weight: bold;
  color: ${colors.green1};
`;
